const PT = require("prop-types");
const React = require("react");
const _ = require("lodash");
const createReactClass = require("create-react-class");
const withBundleLoading = require("../hoc/withBundleLoading");
const withVaultUpdate = require("../hoc/withVaultUpdate");
const LoadingCircle = require("./LoadingCircle");
const ErrorMessage = require("./ErrorMessage");
const ErrorUtil = require("../../../shared/ErrorUtil");
const LoadState = require("../vault/util/LoadState");
const {Portal} = require("./Portal");
const {PORTAL_CONTAINERS} = require("../../../shared/PortalConstants");

const styles = require("./styles/LoadGuard.css");

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withBundleLoading(Component);
	Component = withVaultUpdate(Component, function(props, vaultState) {
		return {connected: vaultState.connected};
	});
	return Component;
};
module.exports = augment(
	createReactClass({
		displayName: "LoadGuard",

		propTypes: {
			// Optional identifier. Used for error checking and debugging only.
			identifier: PT.string,
			// Current load status.
			// Shape depends on whether it's a single or multislot
			status: PT.object,
			// If this load from a multislot, these are the IDs we should check for
			// status
			multiSlotIDs: PT.array,
			// Optional flag. If true, this can still request loads, but it will always
			// render the view as though it is loaded.
			noGuard: PT.bool,
			// bundle to load before the requestLoad call
			needsBundle: PT.string,
			// Function to call to start load if view renders with load status none.
			requestLoad: PT.func,
			// View to render if things are still loading and have not errored.
			loadingView: PT.oneOfType([
				PT.oneOf(["small", "logo"]), // Prebuilt loading views
				PT.node, // Custom loading view
			]),
			loadingViewClass: PT.string,
			logoColorType: PT.string, //Only used if loadingView is "logo"
			chapterLoadingBackground: PT.bool, // whether to display the default loading background for chapter pages
			// View to render if there is an error in loading.
			errorView: PT.oneOfType([
				PT.oneOf(["small", "refresh", "404", "refreshOffice"]), // Prebuilt error views
				PT.node, // Custom error view
			]),
			// A replacement message for the error view. Only affects refreshOffice at the moment.
			errorMessage: PT.string,
			// Alters error view to not take up whole page. Only affects refreshOffice
			// at the moment.
			useSmallErrorView: PT.bool,
			// View to render when loading is done.
			children: PT.node,
			// Alternative to children. Function to call that returns view when loaded.
			// Since rendering the real view often errors if run before the view is
			// loaded, this is an easy way to avoid those errors without an extra if.
			renderLoaded: PT.func,
			// Used when multiple rapid calls are a valid use case (mashing the next lesson button in classroom, etc)
			ignoreLoadLoop: PT.bool,

			// Injected by HOCs
			connected: PT.bool.isRequired,
			requireOrLoadBundle: PT.func.isRequired,
		},

		UNSAFE_componentWillReceiveProps: function(newProps) {
			// This is solely error checking code to prevent browser-crashing
			// infinite loops.
			const {load} = this.getStatus(newProps.status, newProps.multiSlotIDs);
			if (this.props.identifier !== newProps.identifier) {
				this.resetLoadVariables();
			} else if (
				this.hasRequestedLoad &&
				newProps.requestLoad &&
				load === "none"
			) {
				this.handleDoubleLoad();
			} else if (load !== "pending") {
				this.resetLoadVariables();
			}
		},

		componentDidMount: function() {
			this.startLoadIfNeeded();
		},

		componentDidUpdate: function() {
			this.startLoadIfNeeded();
		},

		getStatus: function(status, ids) {
			if (!ids || !ids.length) {
				return status || {load: "done"};
			}
			// We return the status among all ids that appears last in this list.
			const priorityList = ["done", "pending", "error", "none", undefined];
			const maxPriority = _.max(
				ids.map(id => priorityList.indexOf(_.get(status, [id, "status"])))
			);

			const finalStatus = {
				load: priorityList[maxPriority] || "none",
				loadError: null,
			};
			ids.forEach(id => {
				const info = _.get(status, [id], {});
				finalStatus.loadError = finalStatus.loadError || info.error || null;
			});
			if (finalStatus.load === "error") {
				const firstErroredID = _.find(
					ids,
					id => _.get(status, [id, "status"]) === "error"
				);
				finalStatus.loadError = _.get(status, [firstErroredID, "error"]);
			}
			return finalStatus;
		},

		resetLoadVariables: function() {
			this.hasRequestedLoad = false;
			this.hasRequestedLoadAndWaited = false;
			this.preventLoad = false;
			this.awaitBundleForLoadRequest = false;
		},

		handleDoubleLoad: function() {
			// reload is possible since load depends on a bundle which has not been loaded yet
			if (this.awaitBundleForLoadRequest) return;

			// Double loads can happen if a bunch of actions are being processed
			// and our dispatch has to wait for them. Prevent the second load request.
			this.preventLoad = true;

			// If we've waited a bit since our request, that might be an infinite loop.
			if (
				process.env.NODE_ENV !== "production" &&
				this.hasRequestedLoadAndWaited &&
				!this.props.ignoreLoadLoop
			) {
				const message =
					"Same requestLoad function was about to be called consecutively " +
					"in LoadGuard for " +
					this.props.identifier +
					". " +
					"Second call prevented. " +
					"Check that the requestLoad call is changing the status to pending properly. " +
					"(You might have also spammed clicking/other interaction and backed up the action queue.)";
				ErrorUtil.log("E_LOAD_LOOP", message);
			}
		},

		startLoadIfNeeded: function(forceRetry) {
			const {needsBundle, multiSlotIDs} = this.props;
			const status = this.getStatus(this.props.status, multiSlotIDs);
			const shouldLoad =
				status.load === "none" ||
				(status.load === "error" &&
					LoadState.shouldRetryImmediately(status.loadError) &&
					this.props.connected);

			if (
				(shouldLoad || forceRetry || this.awaitBundleForLoadRequest) &&
				this.props.requestLoad &&
				!this.preventLoad
			) {
				this.hasRequestedLoad = true;
				// See handleDoubleLoad for why we need this.
				setTimeout(() => {
					this.hasRequestedLoadAndWaited = true;
				}, 2000);
				if (needsBundle) {
					const bundle = this.props.requireOrLoadBundle(needsBundle);
					if (bundle) {
						this.props.requestLoad();
					} else {
						this.awaitBundleForLoadRequest = true;
					}
				} else {
					this.props.requestLoad();
				}
			} else {
				this.awaitBundleForLoadRequest = false;
			}
		},

		renderLoadingView: function() {
			const v = this.props.loadingView;
			if (v === "small") {
				return <span>Loading...</span>;
			} else if (v === "logo") {
				const backgroundStyles = this.props.chapterLoadingBackground
					? styles.chapterLoadingBackground
					: styles.defaultLoadCenter;
				if (this.props.loadingViewClass) {
					return (
						<div className={backgroundStyles}>
							<div className={this.props.loadingViewClass}>
								<LoadingCircle
									colorType={this.props.logoColorType || "white"}
								/>
							</div>
						</div>
					);
				} else {
					return (
						<Portal container={PORTAL_CONTAINERS.SPINNER}>
							<div className={backgroundStyles}>
								<div className={styles.defaultLoadBox}>
									<LoadingCircle
										colorType={this.props.logoColorType || "white"}
									/>
								</div>
							</div>
						</Portal>
					);
				}
			}
			return v;
		},

		renderErrorView: function() {
			const v = this.props.errorView;
			if (v === "small") {
				return <span>Oops! The data here failed to load.</span>;
			} else if (
				v === "refresh" ||
				v === "refreshOffice" ||
				v === "404" ||
				v === "404Office"
			) {
				let standardMessage = v;
				const {loadError} = this.getStatus(
					this.props.status,
					this.props.multiSlotIDs
				);
				if (!this.props.connected) {
					standardMessage = "connection";
				} else if (loadError === "E_DATABASE") {
					standardMessage = "database";
				}
				// TODO: We should be able to detect from the loadError whether a 404
				// is appropriate and substitute it in. Don't make it available in props.
				return (
					<ErrorMessage
						standardMessage={standardMessage}
						customMessage={this.props.errorMessage}
						isOffice={v === "refreshOffice" || v === "404Office"}
						withHome={v === "404Office"}
						isFull={!this.props.useSmallErrorView}
						reloadFunction={() => this.startLoadIfNeeded(true)}
					/>
				);
			}
			return v;
		},

		render: function() {
			const {load} = this.getStatus(this.props.status, this.props.multiSlotIDs);
			if (load === "done" || this.props.noGuard) {
				if (this.props.renderLoaded) {
					return this.props.renderLoaded() || null;
				} else {
					return this.props.children || null;
				}
			} else if (load === "none" || load === "pending") {
				return this.renderLoadingView() || null;
			} else if (load === "error") {
				return this.renderErrorView() || null;
			}
			return null;
		},
	})
);
